"use strict";

var DocUtils = require("docxtemplater").DocUtils;
DocUtils.convertPixelsToEmus = function (pixel) {
	return Math.round(pixel * 9525);
};
module.exports = DocUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/docxtemplater-image-module-free/js/docUtils.js
// module id = jSZM
// module chunks = 5